export default __webpack_public_path__ + "static/media/onestlatech.123fef2c.png";